<template>
  <el-row class="all">
    <div  v-if="load_show">
      <load></load>
    </div>

    <div class="all_left"  ref="father_file">
      <div ref="back_file">
        <el-page-header @back="$router.go(-1)" content="进行任务" style="margin-bottom: 1.25rem;">
        </el-page-header>
      </div>
      <div class="left_content">
       <iframe :src="file_src" frameborder="0" width="100%" id="myiframe" :height="height" ></iframe>
      </div>
      <div class="left_end" ref="player_div">
         <button @click="button_c('dz')" v-if="dz_button=='1'">已赞</button>
         <button @click="button_c('dz')" v-else>点赞</button>
         <button @click="button_c('sc')" v-if="sc_button=='1'">已收藏</button>
         <button @click="button_c('sc')" v-else>收藏</button>
         <button @click="button_c('fjwj')" v-if="file_link!='0'">附加文档</button>
         <button @click="file_video_b()" style="cursor: pointer;color: white;" v-if=" file_video != '' &&  file_video != '0'">讲解视频</button>
         <div style="float: right; height: 100%; text-align: center;" >
           注意事项：阅读并理解后点击右侧按钮确定<el-button v-show="buttonshowtime" type="success" plain >阅读{{times}}秒可提交</el-button>
          <el-button style="text-align: center;" v-show="buttonshowok"  type="success" plain @click="end_Submit">我已学完</el-button>
         </div>
      </div>
    </div>
    <div class="all_right " >
      <div style="text-align:center; margin-top: 1rem;">
            <p>任务列表</p>
      </div>
          <div
            v-for="(val, key) in plan.list"
            :key="key"
            class="item"
            @click="list_click(val.num,val.time,val.status)"
          >
            <div v-if="val.num == play.num" class="item itemhover itemactive">
              <div class="planname">
                {{ val.name }}
              </div>
              <div class="planstatus">
                <p>{{ val.status }}</p>
              </div>
            </div>
            <div v-else class="item">
              <div class="planname">{{ val.name }}</div>
              <div class="planstatus">
                <p>{{ val.status }}</p>
              </div>
            </div>
          </div>
          <el-button
           v-if="exam.stats!=0"
            style="position: absolute; bottom: 1rem"
            size="medium"
            type="success"
            @click="tasksubject"
            round
            class="addbtn"
            >去考试</el-button
          >
    </div>
    <el-dialog title="电子签名" :visible.sync="autograph.show"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()" :modal-append-to-body='false'>
      请输入您的密码: <el-input show-password v-model="autograph.input" style="margin: 1rem 0 1rem 0 ;"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autograph_click('ok')">确 认</el-button>
         <el-button  @click="autograph_click('on')">取消</el-button>
      </div>
    </el-dialog>
  </el-row>

</template>
<script>
  import pdf from 'vue-pdf'
  import load from '../../../components/load.vue';
  export default {
    name: "App",
    data() {
      return {
        file_video:0,
        load_show:false,
        dz_button:null,
        sc_button:null,
        file_link:'0',
        exam:{
          stats:'1'
        },
        dstimers:null,
        height:'',
        file_src:'',
        simulationlist:[],
        end_div:'',
        buttonshowtime:true,
        buttonshowok:false,
        times:'',
        play: {
         type: '',
         num: '',
         resource: '',
         status:'',
       },
       plan: {
         num: this.$route.query.num,
         type: "file",
         list: [],
         idcard_status:'0'
       },
       autograph:{
         show:false,
         input:'',
       },
      file:{
        item:'',
      },
      };
    },
    components: {
      pdf:pdf,
      load:load
    },
    mounted: function () {
     this.get_task_info('');
     this.change_height();
    },
    methods: {
      file_video_b(){
          window.open('file_video?num='+this.play.num,'_blank')
        },
      tasksubject(){
            let _this=this
            _this.load_show=true
            _this.axios.post('/v2/user_task/check_task_type',{data:{'num':_this.$route.query.num,type:'train'}}).then(function(res) {
              if(res.status=='200'){
                if(res.data.code != 1){
                     _this.$message.error(res.data.msg)
                     _this.load_show=false
                }else{
                  if(res.data.data == 'file'){
                    _this.$message.error('请先完成文档阅读')
                  }else{
                     _this.$router.push({path:'/tasksubject',query:{num:_this.$route.query.num}})
                  }
                  _this.load_show=false
                }
              }else{
                _this.$message.error('服务器内部错误')
                _this.load_show=false
              }
            }).catch(function(error) {
              _this.$message.error('服务器内部错误')
              _this.load_show=false
            });
          },
      end_Submit(){
        let _this=this
        var file_save={
          'file':_this.play.num,
          'train':_this.plan.num
        }
        if(_this.play.status!='已完成'){
          if(_this.plan.idcard_status=='1'){
            _this.autograph.show=true
          }else{
            _this.save_file_end(file_save)
          }
        }
      },

      autograph_click(type){
        let _this=this
        if(type=='ok'){
          if(_this.autograph.input.length==0){
            _this.$message.error('请输入密码')
            return false
          }
          var file_save={
            'file':_this.play.num,
            'train':_this.plan.num
          }
          _this.axios.post('/v2/user_task/task_idcard', {data:{'num':_this.plan.num,'input':_this.autograph.input}}).then(function(res) {
            if (res.status == '200') {
              if (res.data.code == '1') {
                _this.save_file_end(file_save)
                _this.autograph.show=false
                _this.autograph.input=''
              } else {
                _this.$message.error(res.data.msg)
              }
            } else {
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }else{
            _this.autograph.show=false
            _this.autograph.input=''
        }

      },

      closeDialog(){
        this.autograph_click('')
      },

      save_file_end(data){
        let _this=this
        _this.load_show=true
        _this.axios.post("/v2/user_task/save_file", {data:data})
         .then(function (res) {
           if (res.status == "200") {
             _this.play.status='已完成'
             switch(res.data.code){
               case "0":_this.$message.error(res.data.msg);_this.end_div='';break
               case "1":_this.get_task_info('up');_this.$message.success(res.data.msg);break
               case "2":_this.get_task_info('up');_this.$message.success(res.data.msg);break
               default:_this.$message.error("服务器内部错误");_this.end_div='';break
               _this.load_show=false
             }
           } else {
             _this.$message.error("服务器内部错误")
             _this.load_show=false
             _this.end_div=''
           }
         });
      },
      count_down(){
        if(this.times=="0"){
          return
        }
        if(!this.dstimers){
          this.dstimers= setInterval(() => {
            this.times--
            if(this.times<1){
              this.buttonshowtime=false;
              this.buttonshowok=true;
              this.clear_dstimers()
            }
            return;
          }, 1000);
        }

      },
      clear_dstimers(){
        clearInterval( this.dstimers)
        this.dstimers=null
      },
      change_height(){
        let _this=this
        let fatherH = _this.$refs.father_file.offsetHeight
        let footerH = _this.$refs.player_div.offsetHeight
        let backH = _this.$refs.back_file.offsetHeight
        _this.height=fatherH - footerH - backH - 60 + 'px'
        // var frm = document.getElementById('myiframe');
        // console.log(frm.attachEvent )
      },

      //获取列表
       get_task_info(type) {
        let _this = this;
        _this.load_show=true
         _this.axios.get("/v2/user_task/get_task_info", {
            params: { type: _this.plan.type,num: _this.plan.num },
          })
          .then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.plan.list = res.data.data.list
                _this.exam.stats=res.data.data.exam
                _this.plan.idcard_status=res.data.data.idcard_status
                if(type==''){
                    _this.list_click(res.data.data.list[0].num,res.data.data.list[0].time,res.data.data.list[0].status)
                }
                _this.load_show=false
              } else {
                _this.$message.error(res.data.msg);
                _this.load_show=false
              }
            } else {
              _this.$message.error("服务器内部错误");
              _this.load_show=false
            }
          });
      },
      list_click(num,time,status){
        let _this=this
        let  ifmnum=0
        _this.end_div=''
        _this.buttonshowtime=true
        _this.buttonshowok=false
        _this.load_show=true
        if(_this.play.num!=num){
          _this.play.num=num
          _this.play.status=status
          _this.axios.get("/v2/user_resource/get_file_info", {
             params: { file: num,type:'train' },
           })
           .then(function (res) {
             if (res.status == "200") {
                if (res.data.code == "1") {
                  _this.load_show=false
                  _this.times= parseInt(time)+10
                  _this.file_link=res.data.data.file_link
                  _this.dz_button=res.data.data.support
                  _this.sc_button=res.data.data.collect
                  _this.file_src='/pdf?num='+num
                  _this.file_video=res.data.data.video
                  if(_this.dstimers !=null){
                     _this.clear_dstimers()
                      _this.count_down()
                      return
                  }
                  _this.count_down()
               } else {
                 _this.$message.error(res.data.msg);
                 _this.load_show=false
               }
             } else {
               _this.$message.error("服务器内部错误");
               _this.load_show=false
             }
           });
        }
      },
      handleClick() {},
      //点赞收藏事件
      button_c(type){
        let _this=this
        if(type=="dz"){
          _this.support('support','dz_button')
        }else if(type=="sc"){
          _this.support('collect','sc_button')
        }else if(type=="fjwj"){
          // _this.$message.error('附加链接')
         window.open(_this.file_link,'_blank')
        }

      },
      //
      support(opration,button){
        let _this=this
        _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'file',type:'1',num:_this.play.num,opration:opration}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              if(opration=='support'){
                _this.dz_button=res.data.data
              }else{
                _this.sc_button=res.data.data
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

    },

  };
</script>
<style scoped>
  >>>.el-radio__input.is-checked+.el-radio__label {
    color: white;
  }
  >>>.el-radio {
    color: white;
    cursor: pointer;
    margin-right: 30px;
   }
  .p{
    -moz-user-select: none;
    -khtml-user-select: none;
     user-select: none;
  }
  .left_content{
    width: 100%;
    background-color: white;
  }
  .left_end{
      width:100%;
      height: 2.5rem;
      margin-top: 1.5rem;
      background-color: rgb(80, 79, 77);

      color: white;
        }
   .left_end button{
        height: 100%;
        background-color: rgb(80, 79, 77);
        border: none;
        margin-left: 20px;
        color: white;
    }
  .video_div{
    width: calc(100%-30%);
    height: 100%;
    margin: 1% 0px;
    overflow: hidden;
  }

  .addbtn {
     width: calc(30% - 8%);
     margin: 0;
  }
  .planstatus {
    float: right;
    color: #808080;
    font-size: small;
    line-height: 21px;
    margin: 0;
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    height: 40px;
    margin-top: -40px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
  .item {
    padding: 9px;
  }

  .itemactive {
    color: #008000;
    background-color: rgba(231, 245, 255, 0.6) !important;
  }

  .item:hover {
    color: #008000;
    background-color: rgba(231, 245, 255, 0.3);
  }
  .planname {
    width: 80%;
    height: 40px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;

  }
  .all{
    height: 100vh;
    width: 100%;
    z-index: 100;
    background-color: white;
    overflow: hidden;
    display: flex;
    min-height: calc(100vh - 330px);
  }
  .all_right{
    width: calc(30% );
    background-color: #f6f8ff;
    height: 100%;
    overflow: auto;
  }
  .all_left{
    width: 70%;
    margin: 20px;
    overflow: hidden;
    width: 100%;


  }
</style>



// WEBPACK FOOTER //
// src/view/index/Task/Taskfile.vue